import { render, staticRenderFns } from "./CbsLogin.vue?vue&type=template&id=08b7bf90"
import script from "./CbsLogin.vue?vue&type=script&lang=js"
export * from "./CbsLogin.vue?vue&type=script&lang=js"
import style0 from "./CbsLogin.vue?vue&type=style&index=0&id=08b7bf90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports